import * as xlsx from "xlsx";
import * as FileSaver from "file-saver";
import { formatConteudoLiquidoSimilaridade } from "../helpers/formatConteudoLiquidoSimilaridade";

export function exportFileTestSimilaridade(dataPrepared: any[], filetype: string) {
  const rows = (Array.isArray(dataPrepared) ? dataPrepared : []).map((item: any) => {
    const similaridadeFormatada =
      item.SIM_COS != null
        ? `${(Number(item.SIM_COS) * 100).toFixed(2)}%`
        : "";

    return {
      "GTIN": item.GTIN || "",
      "Descrição": item.DESCRICAO || "",
      "Marca": item.MARCA || "",
      "Conteúdo Líquido": formatConteudoLiquidoSimilaridade(item, ""),
      "Similaridade": similaridadeFormatada,
      "Tipo GTIN": item.TIPO_GTIN || ""
    };
  });

  const ws = xlsx.utils.json_to_sheet(rows);

  const wb = {
    Sheets: { data: ws },
    SheetNames: ["data"]
  };

  const excelBuffer = xlsx.write(wb, {
    bookType: filetype === "xls" ? "xls" : "csv",
    type: "array"
  });

  const data = new Blob([excelBuffer]);

  FileSaver.saveAs(data, `resultado_similaridade.${filetype}`);
}
